import { AddressBookIcon, AvatarIcon, BagIcon, FriendsIcon, GiftIcon, HeartOutlineIcon, InfoIcon, ParcelBoxIcon, ProductIcon } from "@shared/ui.icons";
import { Typography } from "@shared/ui.primitives";
import { navigateTo } from "@shared/utils.routing";

import * as styles from "./Nav.css";

const menuItems = {
  ADDRESS_BOOK: {
    label: "Address Book",
    href: "/account/address-book",
    Icon: AddressBookIcon
  },
  JUST_FOR_YOU: {
    label: "Just For You",
    href: "/account/favourites/for-you",
    Icon: ProductIcon
  },
  MEMBER_PERKS: {
    label: "Member Perks",
    href: "/account/member-benefits",
    Icon: GiftIcon
  },
  MEMBERSHIP_AND_BILLING: {
    label: "Membership & Billing",
    href: "/account/my-membership",
    Icon: InfoIcon
  },
  ORDER_HISTORY: {
    label: "Order History",
    href: "/account/order-history",
    Icon: BagIcon
  },
  ORDER_IT_AGAIN: {
    label: "Order It Again",
    href: "/account/favourites/order-it-again",
    Icon: ParcelBoxIcon
  },
  PROFILE: {
    label: "Profile",
    href: "/account/profile",
    Icon: AvatarIcon
  },
  REFER_A_FRIEND: {
    label: "Refer a Friend",
    href: "/account/refer-a-friend",
    Icon: FriendsIcon
  },
  WISHLIST: {
    label: "Wishlist",
    href: "/account/wishlist",
    Icon: HeartOutlineIcon
  },
} as const

const menuByType = {
  member: [
    menuItems.ADDRESS_BOOK,
    menuItems.JUST_FOR_YOU,
    menuItems.MEMBER_PERKS,
    menuItems.MEMBERSHIP_AND_BILLING,
    menuItems.ORDER_HISTORY,
    menuItems.ORDER_IT_AGAIN,
    menuItems.PROFILE,
    menuItems.REFER_A_FRIEND,
    menuItems.WISHLIST,
  ],
  nonMember: [
    menuItems.ADDRESS_BOOK,
    menuItems.MEMBERSHIP_AND_BILLING,
    menuItems.ORDER_HISTORY,
    menuItems.PROFILE,
    menuItems.WISHLIST,
  ]
}

export const Nav: React.FC<{ isMember: boolean; } & React.HTMLAttributes<HTMLElement>> = ({
  isMember,
  ...props
}) => {
  return (
    <nav {...props}>
      <ul className={styles.navList}>
        {menuByType[isMember ? "member" : "nonMember"].map(({ label, Icon, href }) => (
            <Typography as="li" key={label} variant="body-md" colour="primary-dark" onClick={() => navigateTo(href)}>
              <span className={styles.navItem}>
                <Icon className={styles.icon} /> {label}
              </span>
            </Typography>
        ))}
      </ul>
    </nav>
  );
};
